import { httpInterceptor } from '../http-interceptor';

export class WorkTicketService {
  static ENDPOINTS = {
    GET_ALL: 'Planner/getAllChemplastWorkTickets',
    CREATE: 'Planner/createworkticket',
    GET_BY_WORK_ORDER_ID: 'Planner/getChemplastWorkTicketByWorkOrderId',
  };

  static async createWorkTicket(data) {
    return httpInterceptor.post(this.ENDPOINTS.CREATE, data);
  }
  static async getAllWorkTicket(data) {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL);
    
  }
 
  static async getWorkTicketByWorkOrderId(WORKORDERID) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_WORK_ORDER_ID}/${WORKORDERID}`);
  }

  
  
}
